<mat-card class="p-0">
  <mat-card-header class="error-title">
    <mat-card-title class="p-0">Error(s)</mat-card-title>
  </mat-card-header>
  @if (errorMessage) {
    <mat-card-content class="p-2">
      <div> {{errorMessage}} </div>
    </mat-card-content>
  }
  @if (errorMessageList && errorMessageList.length > 0) {
    <mat-card-content class="p-2">
      @for (errorMessage of errorMessageList; track errorMessage) {
        <div> {{errorMessage}} </div>
      }
    </mat-card-content>
  }
  <mat-card-footer>

  </mat-card-footer>
</mat-card>
